import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { errorMessage, successMessage } from "../../utils/alertMessage";
import { addBank, addLoanFile, getBanker, getLoanFileStatus, updateBank, updateLoanFile } from "../../services/userMasterUser";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { getUserData } from "../../utils/localStorage";
import { Calendar } from "primereact/calendar";

export default function LoanFileCreate() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const { userProfileData } = getUserData();

  const [bankerList, setBankerList] = useState([])

  const [input, setInput] = useState({
    bankerId: state?.loanFileEdit?.banker?.id || "",
    fileNo: state?.loanFileEdit?.fileNo || "",
    requestAmount: state?.loanFileEdit?.requestAmount || "",
    fileStatus: state?.loanFileEdit?.fileStatus || "REQUESTED", // create → requested, disburset, sancation, declined
    remarks: state?.loanFileEdit?.remarks || "",
    disbursedAmount: state?.loanFileEdit?.disbursedAmount || "",
    disbursedDate: state?.loanFileEdit?.disbursedDate || new Date(),
    sanctionAmount: state?.loanFileEdit?.sanctionAmount || "",
    sanctionDate: state?.loanFileEdit?.sanctionDate || new Date(),
  });
  const [errors, setErrors] = useState({
    bankerId: "",
    fileNo: "",
    requestAmount: "",
    fileStatus: "",
    remarks: "",
    disbursedAmount: "",
    disbursedDate: "",
    sanctionAmount: "",
    sanctionDate: "",
  });

  const [fileStatusData, setFileStatusData] = useState([]);    
  // useEffect(() => {
  //   if (state) {
  //     setInput(prevState => ({
  //       ...prevState,
  //       status: state?.status,
  //     }));
  //   }
  // }, [state]);


  const fetchData = (data) => {

    getBanker(data)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs

          const activeBanker = newData.filter((item) => item.status === "ACTIVE");
          const bankerDataList = activeBanker.map((item) => ({
            label: item?.city + "-" + item?.bank?.name + "-" + item?.bank?.category + "-" + item.nameOfBanker + "-" + item?.mobile + "-Limit: " + "Min-" + item?.minimumLoanAmount + ", Max-" + item?.maximumLoanAmount,
            value: item.id,
          }));

          setBankerList(bankerDataList);

        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })

  };

  useEffect(() => {
    fetchData(
      {
        searchBy: "",
        searchText: "",
        limit: 100000,
        offset: 0,
        sortBy: "",
        sortOrder: "desc",
        statusIn: []
      });

    

    getLoanFileStatus()
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs

          const dataList = newData.map((item) => ({
            label: item,
            value: item,
          }));

          setFileStatusData(dataList);

        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })
  }, []);



  
  const bankCategoryList = [
    { label: "Nationalised Bank", value: "Nationalised bank" },
    { label: "Private Bank", value: "Private Bank" },
    { label: "Financial Institution", value: "Financial Institution" },
    { label: "Small Bank", value: "Small Bank" },
    { label: "Alternative Investment Fund", value: "Alternative Investment Fund" },
  ]

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    // Example: Validate email format
    // const emailRegex = /^\S+@\S+\.\S+$/;

    // if (!(input.fileNo)) {
    //   newErrors.fileNo = "Please Enter File No";
    //   isValid = false;
    // } else {
    //   newErrors.fileNo = "";
    // }

    // if (!(input.bankerId)) {
    //   newErrors.bankerId = "Please Select Banker";
    //   isValid = false;
    // } else {
    //   newErrors.bankerId = "";
    // }

    // if (!(input.requestAmount)) {
    //   newErrors.requestAmount = "Please Enter Request Amount";
    //   isValid = false;
    // } else {
    //   newErrors.requestAmount = "";
    // }


    // if (!(input.remarks)) {
    //   newErrors.remarks = "Please Enter Remarks";
    //   isValid = false;
    // } else {
    //   newErrors.remarks = "";
    // }



    // Add more validation logic for other fields as needed

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      if (state?.loanFileEdit) {
        let data = {
          id: state?.loanFileEdit?.id,
          banker: {
            id: input.bankerId,
          },
          fileNo: input.fileNo,
          requestAmount: input.requestAmount,
          fileStatus: input.fileStatus,
          remarks: input.remarks,
          disbursedAmount: input.disbursedAmount,
          disbursedOn: input.disbursedDate,
          sanctionAmount: input.sanctionAmount,
          sanctionOn: input.sanctionDate,
        };

        updateLoanFile(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/view-loan-file", {
                 state: state?.leadId
                });
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      } else {
        let data = {
          lead: {
            id: state?.leadId?.id
          },
          user: {
            id: userProfileData?.id
          },
          banker: {
            id: input.bankerId,
          },
          fileNo: input.fileNo,
          requestAmount: input.requestAmount,
          fileStatus: input.fileStatus,
          remarks: input.remarks

        };

        addLoanFile(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/view-loan-file", {
                  state: state?.leadId
                });
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      }
    }
  };

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <h5 className="card-title flex">
                  <div
                    className="mr-3 cursor-pointer"
                    onClick={() => navigate("/view-loan-file", {
                      state: state?.leadId
                    })}
                  >
                    <i class="bi bi-arrow-left-circle-fill"></i>
                  </div> Loan File {state?.loanFileEdit ? "Update" : "Create"}
                </h5>
                <form onSubmit={handleSubmit}>
                  <div className="row mb-3">

                    <div className="col-md-12">
                      <label htmlFor="bankerId" className="form-label">
                        Banker Id
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={bankerList}
                        value={input.bankerId}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            bankerId: e.value,
                          });
                        }}
                        optionLabel="label"
                      />
                    </div>

                  </div>
                  <div className="row mb-3">
                    <div className="col-md-12">
                      <label htmlFor="score" className="form-label">
                        File No
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="fileNo"
                        name="fileNo"
                        value={input.fileNo}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            fileNo: e.target.value,
                          });
                        }}
                        required
                      />
                    </div>
                    

                  </div>
                  

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Request Amount
                      </label>
                      <InputText
                        type="number"
                        style={{ width: "100%" }}
                        id="requestAmount"
                        name="requestAmount"
                        value={input.requestAmount}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            requestAmount: e.target.value,
                          });
                        }}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Remarks
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="remarks"
                        name="remarks"
                        value={input.remarks}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            remarks: e.target.value,
                          });
                        }}
                        required
                      />
                    </div>

                  </div>

                  {state?.loanFileEdit?.id &&
                    <div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label htmlFor="score" className="form-label">
                          Disbursed Amount
                        </label>
                        <InputText
                          type="number"
                          style={{ width: "100%" }}
                          id="disbursedAmount"
                          name="disbursedAmount"
                          value={input.disbursedAmount}
                          onChange={(e) => {
                            setInput({
                              ...input,
                              disbursedAmount: e.target.value,
                            });
                          }}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                          <label htmlFor="disbursedOn" className="form-label">
                            Disbursed Date
                        </label>
                         <Calendar
                          id="buttondisplay"
                            value={input.disbursedDate}
                            onChange={(e) => setInput({
                              ...input,
                              disbursedDate: e.target.value,
                            })}
                            showIcon
                            dateFormat="dd/mm/yy"
                            style={{ width: "100%" }}
                          />
                      </div>

                    </div>
                  <div className="row mb-3">
                      <div className="col-md-6">
                        <label htmlFor="score" className="form-label">
                          Sanction Amount
                        </label>
                        <InputText
                          type="number"
                          style={{ width: "100%" }}
                          id="sanctionAmount"
                            name="sanctionAmount"
                            value={input.sanctionAmount}
                          onChange={(e) => {
                            setInput({
                              ...input,
                              sanctionAmount: e.target.value,
                            });
                          }}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="bankerId" className="form-label">
                            Sanction Date
                        </label>
                          <Calendar
                            id="sanctionDate"
                            value={input.sanctionDate}
                            onChange={(e) => setInput({
                              ...input,
                              sanctionDate: e.target.value,
                            })}
                            showIcon
                            dateFormat="dd/mm/yy"
                            style={{ width: "100%" }}
                          />
                      </div>

                    </div>
                    </div>
                  }

                  <div className="row mb-3">
                    <div className="col-md-12">
                      <label htmlFor="fileStatus" className="form-label">
                        File Status
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={fileStatusData}
                        value={input.fileStatus}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            fileStatus: e.value,
                          });
                        }}
                        disabled={state?.loanFileEdit?.id ? false : true}
                      />
                      
                    </div>
                  </div>
                  <div className="col-md-12 text-center">
                    <button type="submit" className="move-btn move-btn-blue">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
